import { CommonModule } from '@angular/common';
import { ApplicationRef } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { StoreModule } from '@ngrx/store';
import { ConfigModule } from 'Angular/config/config.module';
import { NavigationModule } from 'Angular/features/components/navigation/navigation.module';
import { SideMenuModule } from 'Angular/features/components/side-menu/side-menu.module';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { IconSearchAutocompleteModule } from 'SearchApp/ts/features/icon-search-autocomplete/icon-search-autocomplete.module';
import { TopBarNavComponent } from 'Angular/features/components/navigation/top-bar-nav/top-bar-nav.component';
import { SideMenuComponent } from 'Angular/features/components/side-menu/side-menu.component';
import { PageToastMessagesComponent } from 'Angular/features/components/toast-messages/page-toast-messages.component';
import { GlossaryIndexComponent } from 'GlossaryApp/ts/apps/glossary-index-app/components/glossary-index/glossary-index.component';
import { getLogger } from 'Angular/state/logger';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
export class AppModule {
    ngDoBootstrap(appRef) {
        appRef.bootstrap(GlossaryIndexComponent);
        appRef.bootstrap(SideMenuComponent);
        appRef.bootstrap(TopBarNavComponent);
    }
}
AppModule.ɵfac = function AppModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AppModule)(); };
AppModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: AppModule });
AppModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [BrowserModule,
        CommonModule,
        ConfigModule,
        IconModule,
        IconSearchAutocompleteModule,
        NavigationModule,
        PageToastMessagesComponent,
        SideMenuModule,
        StoreModule.forRoot({}, { metaReducers: getLogger() })] });
